<template lang="pug">
  v-data-table.elevation-1(:headers="headers" :items="items" )
    template(v-slot:top="")
      v-toolbar(flat="" color="white")
        v-toolbar-title Preguntas Frecuentes
        v-divider.mx-4(inset="" vertical="")
        v-spacer
        v-dialog(v-model="preview" max-width="500px")
          v-card
            v-card-title
              span.headline Vista Previa
            v-card-text
              v-container
                v-row
                  v-col(cols="12" )
                    v-text-field(readonly v-model="editedItem.title" label="Titulo")
                  v-col(cols="12")
                    v-select( readonly :items='field.types.choices', label="Tipo de Usuario", v-model='editedItem.type')
                  v-col(cols="12")
                    v-textarea( readonly outlined v-model="editedItem.content" label="Contenido")
            v-card-actions
              v-spacer
              v-btn(color="blue darken-1" text="" @click="close") Cerrar
        v-dialog(v-model="dialog" max-width="500px")
          template(v-slot:activator="{ on, attrs }")
            v-btn.mb-2(color="primary" dark="" v-bind="attrs" v-on="on") Nuevo Item
          v-card
            v-card-title
              span.headline {{ formTitle }}
            v-card-text
              v-container
                v-row
                  v-col(cols="12" )
                    v-text-field(v-model="editedItem.title" label="Titulo")
                  v-col(cols="12" )
                    v-select(  :items='field.types.choices', label="Tipo de Usuario", v-model='editedItem.type')
                  v-col(cols="12")
                    v-textarea(outlined v-model="editedItem.content" label="Contenido")
            v-card-actions
              v-spacer
              v-btn(color="blue darken-1" text="" @click="close") Cancelar
              v-btn(color="blue darken-1" text="" @click="save") Guardar
    template(v-slot:item.actions="{ item }")
      v-icon.mr-2(small="" @click="previewFaq(item)")
        | mdi-eye
      v-icon.mr-2(small="" @click="editItem(item)")
        | mdi-pencil
      v-icon(small="" @click="deleteItem(item)")
        | mdi-delete
    template(v-slot:no-data="")
      v-btn(color="primary" @click="initialize") Reiniciar
</template>

<script>
  export default {
    name: 'FAQ',
    data: () => ({
      dialog: false,
      preview: false,
      field: {
        types: {
          choices: ['Contributor', 'Customer'],
        },
      },
      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: 'User type',
          align: 'start',
          sortable: true,
          value: 'type',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        title: '',
        content: '',
        type: '',
      },
      defaultItem: {
        title: '',
        content: '',
        type: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      items () {
        return this.$store.getters['cms/getFaqs']
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      preview (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('cms/loadFaqs')
      },
      previewFaq (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.preview = true
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.$store.dispatch('cms/deleteFaq', item)
      },

      close () {
        this.dialog = false
        this.preview = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        const vm = this
        vm.editedIndex = vm.items.find(function (item) { return item.id === vm.editedItem.id })
        // console.log(vm.editedIndex)
        if (vm.editedIndex) {
          // console.log('entra en el if', vm.editedItem)
          vm.$store.dispatch('cms/updateFaq', vm.editedItem)
        } else {
          // console.log('entra en el else', vm.editedItem)
          vm.$store.dispatch('cms/createFaq', vm.editedItem)
        }
        vm.close()
      },
    },
  }
</script>

<style scoped>

</style>
